import { render } from "./UspsHero.vue?vue&type=template&id=1cea0100"
const script = {}
script.render = render

export default script